/**
 * SemAcesso — o que a rota mostra quando o PAPEL não abre aquela tela (padrão A, item 4).
 *
 * Antes o painel abria a tela, a API respondia 403 e ficava um erro genérico (ou, em rota desconhecida,
 * um redirecionamento mudo para o Dashboard). Agora a casca checa o registro ANTES de montar a tela: diz o
 * motivo, diz quem abre e leva à primeira tela do perfil. A tela barrada nem é montada (não dispara
 * requisição que sabidamente volta 403). É só apresentação: quem barra de verdade é a permissão de cada
 * rota da API.
 */
import { LockKeyhole } from "lucide-react";
import type { RenderLinkShell } from "./tipos.js";

export function SemAcesso({
  rotulo,
  papelRotulo,
  quemAbre,
  destino,
  renderLink,
}: {
  rotulo: string;
  papelRotulo: string;
  /** Nomes dos papéis que abrem a tela ("Master, Admin de Segurança…"). */
  quemAbre: string;
  destino: { href: string; rotulo: string } | null;
  renderLink: RenderLinkShell;
}) {
  return (
    <div className="casca-aviso-tela" role="region" aria-labelledby="sem-acesso-titulo">
      <LockKeyhole size={28} aria-hidden="true" className="casca-aviso-icone" />
      <h1 id="sem-acesso-titulo" className="casca-aviso-titulo">Sem acesso a “{rotulo}”</h1>
      <p>Seu perfil ({papelRotulo}) não abre esta tela.</p>
      {quemAbre && <p>Quem abre: {quemAbre}.</p>}
      <p>Se você precisa dela para o seu trabalho, peça a liberação a um administrador do sistema.</p>
      {destino && (
        <p>
          {renderLink({ href: destino.href, className: "casca-acao", children: <>Ir para {destino.rotulo}</> })}
        </p>
      )}
    </div>
  );
}
